import { Box } from "@mantine/core";
import { useTranslation } from "react-i18next";
import classes from "./StepIndicator.module.css";

export interface StepIndicatorProps {
  steps: string[];
  /** 0-ээс эхэлнэ. */
  current: number;
}

/** Алхмын заагч (хуучин нэр AuthSteps). */
export function StepIndicator({ steps, current }: StepIndicatorProps) {
  const { t } = useTranslation("auth");
  return (
    <Box component="ol" className={classes.root} aria-label={t("forgot.stepsLabel")}>
      {steps.map((label, i) => (
        <Box
          component="li"
          key={label}
          className={classes.step}
          aria-current={i === current ? "step" : undefined}
          data-current={i === current || undefined}
          data-done={i < current || undefined}
        >
          {label}
        </Box>
      ))}
    </Box>
  );
}
